import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  currentYear: number = new Date().getFullYear();

  ngOnInit(): void {
    const navScroll = document.querySelector('.navbar');
    window.addEventListener('scroll', () => {
      if (window.scrollY>=56){
        navScroll?.classList.add('navbar-scrolled');
      }else if (window.scrollY<56){
        navScroll?.classList.remove('navbar-scrolled');
      }
    });
    const navLinks = document.querySelectorAll('.nav.navbar-right a');
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        const activeLinks = document.querySelectorAll('.nav.navbar-right li.active');
        activeLinks.forEach(activeLink => activeLink.classList.remove('active'));
        link.parentElement?.classList.add('active');
      });
    });
    

  }
  title = 'MCLabs';
}
